"use client";
import classNames from "classnames";
import styles from "./styles.module.scss";
import React, { useEffect, useRef, useState } from "react";
import { prismicSerializer } from "@/lib/helpers";
import { PrismicRichText } from "@prismicio/react";
import Image from "next/image";

export default function Component({ data, url }) {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [goToNextSlide, setGoToNextSlide] = useState();

  const slidesRef = useRef();
  const slidesContainerRef = useRef();
  const [startX, setStartX] = useState(null);
  const [endX, setEndX] = useState(null);
  const [translateX, setTranslateX] = useState(0);
  const [isPressSlide, setIsPressSlide] = useState(false);

  const handleNext = () => {
    if (currentSlide >= data.length - 1) return;
    goToSlide(currentSlide + 1);
    setGoToNextSlide(true);
  };
  const handlePrev = () => {
    if (currentSlide <= 0) return;
    goToSlide(currentSlide - 1);
    setGoToNextSlide(false);
  };

  const goToSlide = index => {
    const slideWidth = slidesContainerRef.current.getBoundingClientRect().width;
    var updatedTranslateX = -slideWidth * index;
    setTranslateX(updatedTranslateX);
    slidesRef.current.style.transform = `translateX(${updatedTranslateX}px)`;
    setCurrentSlide(index);
  };

  const handleTouchStart = (e, isTouch = true) => {
    if (isTouch) {
      const touchStartX = e.touches[0].clientX;
      setStartX(touchStartX);
    } else {
      setStartX(e.clientX);
    }
  };

  const handleTouchMove = (e, isTouch = true) => {
    const slideWidth = slidesContainerRef.current.getBoundingClientRect().width;
    var touchMoveX;
    if (isTouch) {
      touchMoveX = e.touches[0].clientX;
    } else {
      touchMoveX = e.clientX;
    }
    if (Math.abs(touchMoveX - startX) <= slideWidth / 2 && currentSlide >= 0 && currentSlide <= data.length - 1) {
      slidesRef.current.style.transform = `translateX(${touchMoveX - startX + translateX}px)`;
    }
    if (touchMoveX !== 0) {
      setEndX(touchMoveX);
    }
  };
  const handleTouchEnd = (e, isTouch = true) => {
    if (startX - endX > 50 && currentSlide < data.length - 1) {
      handleNext();
    } else if (startX - endX < -50 && currentSlide > 0) {
      handlePrev();
    } else {
      slidesRef.current.style.transform = `translateX(${translateX}px)`;
    }
  };

  const [slideItemWidth, setSlideItemWidth] = useState("100%");

  useEffect(() => {
    const slideWidth = slidesContainerRef.current.getBoundingClientRect().width;
    setSlideItemWidth(slideWidth);
  }, []);

  const handleDragStart = e => {
    setIsPressSlide(true);
    if (window.innerWidth > 1024) handleTouchStart(e, false);
  };

  const handleDragEnd = e => {
    setIsPressSlide(false);
    if (window.innerWidth > 1024) handleTouchEnd(e, false);
  };

  const handleDrag = e => {
    if (window.innerWidth > 1024 && isPressSlide) {
      handleTouchMove(e, false);
    }
  };
  const handleMouseUpDocument = e => {
    setIsPressSlide(false);
  };

  useEffect(() => {
    window.addEventListener("mouseup", handleMouseUpDocument);

    return () => {
      window.removeEventListener("mouseup", handleMouseUpDocument);
    };
  }, []);

  return (
    <div className="h-[237px] lg:h-[462px] relative">
      <div ref={slidesContainerRef} className="w-full ">
        <div className="overflow-hidden relative">
          <div
            ref={slidesRef}
            draggable={false}
            onMouseDown={handleDragStart}
            onDrag={handleDrag}
            onDragEnd={handleDragEnd}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
            className={classNames(styles.slideWrap)}
          >
            {data.map((item, index) => (
              <div
                key={`review-${index}`}
                className="slide-wrap  max-w-[1242px] w-full h-auto lg:h-[462px] flex flex-col lg:flex-row justify-between items-center"
                style={{ minWidth: slideItemWidth }}
              >
                <div className="w-full lg:w-1/2 h-[60vw] lg:h-full">
                  <Image src={item.image.url} alt={item.image.alt} width="500" height="500" className="w-full h-full" />
                </div>
                <div className={classNames(" h-fit lg:h-full flex relative bg-transparent", styles.content)}>
                  <div draggable={true} className={styles.text}>
                    <PrismicRichText field={item.image_text} components={prismicSerializer(url)} />
                  </div>
                  <div className="absolute bottom-0 left-1/4 font-bold text-sm hidden lg:flex">
                    {(index + 1).toString().padStart(2, "0")} / {data.length.toString().padStart(2, "0")}
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className={classNames("flex lg:hidden", styles.owlDots)}>
            {data.length > 1 &&
              data.map((_, index) => (
                <div
                  key={`owl-dot-${index}`}
                  onClick={() => goToSlide(index)}
                  className={classNames(styles.owlDot, index === currentSlide && styles.active)}
                ></div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
}
